import { render, staticRenderFns } from "./cnpj-format.vue?vue&type=template&id=39cf6614&scoped=true&lang=pug&"
import script from "./cnpj-format.vue?vue&type=script&lang=ts&"
export * from "./cnpj-format.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf6614",
  null
  
)

export default component.exports